/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProductSwiper_item = {
    readonly carouselPhotos: ReadonlyArray<{
        readonly smallPath: string | null;
        readonly masterOrZoomPath: string | null;
        readonly " $fragmentRefs": FragmentRefs<"ThumbImage_photo">;
    } | null> | null;
    readonly viewInRoomPhotos: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"ViewInRoomImage_viewInRoomPhoto">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"ViewInRoomImage_item">;
    readonly " $refType": "ProductSwiper_item";
};
export type ProductSwiper_item$data = ProductSwiper_item;
export type ProductSwiper_item$key = {
    readonly " $data"?: ProductSwiper_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ProductSwiper_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "photosLimit"
    },
    {
      "defaultValue": 0,
      "kind": "LocalArgument",
      "name": "viewInRoomLimit"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductSwiper_item",
  "selections": [
    {
      "alias": "carouselPhotos",
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "photosLimit"
        }
      ],
      "concreteType": "ItemPhoto",
      "kind": "LinkedField",
      "name": "photos",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "smallPath",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "masterOrZoomPath",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ThumbImage_photo"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "limit",
          "variableName": "viewInRoomLimit"
        }
      ],
      "concreteType": "viewInRoomPhotos",
      "kind": "LinkedField",
      "name": "viewInRoomPhotos",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ViewInRoomImage_viewInRoomPhoto"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoomImage_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '618eb49baae55feadd5abdaf9a64153a';
export default node;
